import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import Table from "@components/Table";

import { Box, Container } from "@mui/material";
import { PagesID } from "@utils/utilsConfigurations";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import ButtonBackPage from "@components/ButtonBackPage";
import BackgroundImageCst from "@components/BackgroundImageCst";
import { useParams } from "react-router-dom";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { ServicesURL } from "@utils/utilsApi";
import { useAuth } from "@context/auth";
import { useFilters } from "@context/filters";
import CustomTopToolbar from "@components/Table/components/CustomTopToolbar";
import FormLoadingStateCst from "@components/FormLoadingStateCst";
import { ListClusterUser } from "../types";

const Users: React.FC<{ page: PagesID }> = ({ page }) => {
  const { id, initiativeId, clusterId } = useParams();
  const { user } = useAuth();
  const { filters } = useFilters();
  const filterId = `${user?.id_user}_${page + initiativeId}${clusterId}`;

  const { columns, actionsTopToolbar, actionForRow, dataTable, isLoading } =
    useFetchTable(
      ServicesURL.getCommunityClusterUsers
        .replace(":corporateId", id ?? "1")
        .replace(":initiativeId", initiativeId ?? "")
        .replace(":clusterId", clusterId ?? ""),
      PagesID["corporate.initiative.community-cluster.users"],
      filters[filterId],
    );

  const { t } = useTranslation(["community-cluster-page"]);

  const customRenderTopToolbar = ({
    table,
  }: {
    table: any;
  }): React.ReactNode => {
    return columns ? (
      <CustomTopToolbar
        id={`${page + initiativeId}${clusterId}`}
        key={`custom_top_toolbar_${page}`}
        columns={columns
          .filter((column) => (column as any)["hasFilter"])
          .map((column) => ({
            ...column,
            visibility: true,
            visibilityInTable: true,
          }))}
        configurationTopToolbar={actionsTopToolbar}
        table={table}
        hiddenFilters={false}
        resetFormFilters={undefined}
        setHideHeader={undefined}
        counterElements={false}
        onToolbarChange={() => {}}
        modalTitle={undefined}
        noSummarySelected={undefined}
        filtersException={undefined}
        enableFullScreenToggle={false}
      />
    ) : (
      <></>
    );
  };

  const dataMapper = (dataTableObj?: ListClusterUser) => {
    return (
      dataTableObj?.output.map(
        ({ external_id, id, email, group_id, group_name, name, surname }) => {
          return {
            external_id,
            id,
            email,
            group_id: group_id?.join(","),
            group_name: group_name?.join(","),
            name,
            surname,
          };
        },
      ) ?? []
    );
  };

  return (
    <>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-community.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst title={t("users.hero-title")} description={""} />
        <ButtonBackPage />
        <Box
          sx={{
            mt: "25px",
          }}
        >
          {isLoading ? (
            <FormLoadingStateCst />
          ) : (
            <Table
              id={`${page + initiativeId}${clusterId}`}
              data={dataMapper(dataTable)}
              columns={columns || []}
              configurationTopToolbar={actionsTopToolbar}
              totalPages={dataTable?.metadata?.total_elements}
              renderTopToolbar={customRenderTopToolbar}
              enableRowActions={false}
            />
          )}
        </Box>
      </Container>
    </>
  );
};

export default Users;
